<script>
/**
 * @overview  全局名称搜索组件
 *
 * @author  huojinzhao
 */

export default {
  name: "AppQueryName",

  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newValue: "",
    };
  },
  watch: {
    value(vl) {
      this.newValue = vl;
    },
    newValue(vl) {
      this.$emit("update:value", vl);
    },
  },
  mounted() {
    this.newValue = this.value;
  },

  methods: {
    queryName() {
      const value = this.newValue;
      this.$emit("query");
    },
  },
};
</script>

<template>
  <el-input
    ref="nameInput"
    v-model="newValue"
    size="small"
    class="app-query-name"
    placeholder="输入搜索名称"
    @keydown.enter.native="queryName"
  >
    <el-button
      slot="append"
      icon="el-icon-search"
      @click="queryName"
    />
  </el-input>
</template>

<style lang="postcss">
.app-query-name {
  width: auto;
}
</style>

